<template>
    <div class="teachingActivity">
        <div class="table-data">
            <el-table :data="tableData" style="height: 100%;">
               <el-table-column prop="s_name" label="学生姓名" align="center"></el-table-column>
               <el-table-column prop="score" label="成绩" align="center"></el-table-column>
               <el-table-column prop="create_time" label="提交时间" align="center"></el-table-column>
               <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                      <span :class="Number(scope.row.status) === 2 ? 'red':''">{{ statusLists[scope.row.status] }}</span>
                  </template>
               </el-table-column>
               <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                     <el-link type="primary" v-if="Number(scope.row.status) > 0" 
                      :underline="false" @click="toNextPage(scope.row)">
                        {{ [1,3].includes(Number(scope.row.status)) ? "查看": "批阅" }}
                     </el-link>
                  </template>
               </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :total="total">
          </el-pagination>
        </div>
    </div>
</template>
    
<script>
import {markListData} from "@/utils/apis"
import common from "../../../utils/common";
  export default {
    name: "teacherTextbook",
    components: {},
    data() {
      return {
        query: JSON.parse(localStorage.getItem("query")) || null,
        page: 1,
        pageSize: 10,
        total: 0,
        class_id: Number(localStorage.getItem("class_id")) || null,
        tableData: [],
        statusLists: [
          "未提交",
          "已批阅",
          "未批阅",
          "无需批阅",
        ],
      };
    },
    created() {
      this.getStuScoreList()
    },
    mounted() {},
    methods: {
      pageChange(val) {
          this.page = val
          this.getStuScoreList();
      },
      getStuScoreList() {
          const params = {
              page: this.page,
              limit: this.pageSize,
              id: this.query.id,
              class_id: this.class_id
          }
          markListData(params).then(({code, msg, data}) => {
              if (code === 200) {
                  this.total = data.total
                  console.log("total", this.total)
                  this.tableData = data.list

              }
          }).catch(err => common.axiosErrorMsg(err))
      },
      toNextPage(row) {
        this.$router.push({path: "/teach/mark", query: {stu_id: row.s_id, id: this.query.id, mark: row.status}})
      }

    },
  };
</script>
    
<style scoped lang="scss">
  .teachingActivity {
    &, & * {
      box-sizing: border-box;
    }
    width: 100%;
    height: 100%;
    .table-data {
      width: 100%;
      height: calc(100% - 50px);
    }
    .pagination {
       width: 100%;
       height: 50px;
       display: flex;
       justify-content: center;
       align-items: center;
    }
  }
</style>